module.exports = __webpack_public_path__ + "img/017-tablet.50a95f43.svg";